/* eslint-disable max-len */

import React, { Component } from 'react';
import moment from 'moment';
import cn from 'classname';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import mapValues from 'lodash/mapValues';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import flatten from 'lodash/flatten';
import filter from 'lodash/filter';
import isNil from 'lodash/isNil';
import sumBy from 'lodash/sumBy';
import mean from 'lodash/mean';
import uniq from 'lodash/uniq';
import get from 'lodash/get';
import map from 'lodash/map';

import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/filters/main';

import { formatMoney } from '../../../../../shared/js/format';

import wrapMain from '../wrap-main';

import { selectors, actions } from './';

import './index.less';

const IS_EVERAD = process.env.CPA_ENV === 'everad';

function renderConversionsTDs(id, amount, profit) {
	return [
		<td key={'amount:' + id}>
			{formatMoney(amount)}
		</td>,
		<td key={'profit:' + id} className='marketing-funnel-profit'>
			{!isNil(profit) ? formatMoney(profit) + '$' : '?'}
		</td>
	];
}

function renderTDs(id, count, targetCount, link) {
	const isPercentNeeded = !isNil(targetCount);

	const tds = [
		<td
			colSpan={isPercentNeeded ? 1 : 2}
			key={'count:' + id}
		>
			{!link ? count : count && (
				<Link
					onClick={(e) => {
						e.preventDefault();
						const url = new URL(`https://ckp1.com${link}`); // can be any domain
						localStorage.setItem('tempQueryString', url.search);
						window.open(IS_EVERAD ? url.pathname : url.pathname + url.search, '_blank');
					}}
					to={link}
				>
					{count}
				</Link>
			)}
		</td>
	];

	if (isPercentNeeded) {
		tds.push((
			<td key={'percent:' + id}>
				{percent(count, targetCount)}
			</td>
		));
	}

	return tds;
}

function percent(count, total) {
	const p = Math.round(count / total * 100);
	return !isNaN(p) && isFinite(p) ? p + '%' : '−';
}

class Table extends Component {
	constructor(props) {
		super(props);

		this.state = {
			levels: [],
			sorting: {}
		};

		this.toggleLevel = this.toggleLevel.bind(this);
	}

	toggleLevel(level) {
		this.setState((state) => {
			return {
				levels: state.levels.includes(level)
					? state.levels.filter((l) => l !== level)
					: state.levels.concat(level)
			};
		});
	}

	sort(index) {
		this.setState((state) => {
			const isSameColumn = state.sorting.index === index;

			return {
				...state,
				sorting: isSameColumn && state.sorting.direction === 'asc' ? {} : {
					index,
					direction: isSameColumn ? !state.sorting.direction ? 'desc' : 'asc' : 'desc'
				}
			};
		});
	}

	transformation(path, key, filters, mapper, createWithTotal) {
		const rows = get(this.props.data, path);

		const groupify = (array, by) => mapValues(groupBy(array, by), (affiliates) => uniq(affiliates.map((a) => a.email)));

		function createNode(filters) {
			const name = Object.keys(filters)[0];
			return createWithTotal({
				name, title: filters[name], months: rows.map(mapper(filters))
			});
		}

		const array = flatten(rows.map((row) => filter(row[key], filters)));

		return map(groupify(array, 'field'), (emails, field) => {
			field = field === 'null' ? null : field;

			return {
				...createNode({ field }),
				list: field
					? emails.map((email) => createNode({ email, field }))
					: map(groupify(filter(array, { field }), 'referer_domain'), (emails, referer_domain) => ({
						...createNode({ referer_domain, field }),
						list: emails.map((email) => createNode({ email, field, referer_domain }))
					}))
			};
		});
	}
	sortBy(list, path) {
		const { index, direction } = this.state.sorting;

		const sortingPath = !direction ? 'title' : `${!isNil(index) ? `months[${index}]` : 'total'}.${path}`;

		function traversal(tree) {
			for (const node of tree) {
				if (node.list) {
					node.list = traversal(node.list);
				}
			}

			return orderBy(tree, sortingPath, direction);
		}

		return traversal(list);
	}
	renderList(id, list, render) {
		const toggleLevel = this.toggleLevel;
		const levels = this.state.levels;
		const intl = this.props.intl;

		function traversal(tree, id, level = 2) {
			const trs = [];

			for (const { name, title, total, months, list } of tree) {
				const key = `${id}:${name}:${title}`;

				trs.push((
					<tr className={`level-${level}`} key={key}>
						<td className='sticky'>
							{list ? (
								<button onClick={() => toggleLevel(key)}>
									<span>{levels.includes(key) ? '—' : '+'}</span>{title || intl('Остальные')}
								</button>
							) : (
								<div>
									{title}
								</div>
							)}
						</td>

						{render(`${name}:total`, total)}
						{months.map((month, i) => render(`${name}:${i}`, month))}
					</tr>
				));

				if (list && levels.includes(key)) {
					trs.push(...traversal(list, key, level + 1));
				}
			}

			return trs;
		}

		return traversal(list, id);
	}

	requestAffiliatesLink(entity, key) {
		if (['activated_affiliates'].includes(key)) {
			return IS_EVERAD
				? `/marketing-funnel/affiliate-stat?${this.props.createAffiliateStatQueryString(entity[key])}`
				: `/statistics/general?${this.props.createStatisticsQueryString(entity[key])}`;
		}
	}

	renderAverageActivationDays(path) {
		const { intl, data: { $total, [path]: { registrations } } } = this.props;

		const levels = this.state.levels;

		const averages = registrations.map((row) => mean(row.activated_affiliates.map((a) => {
			return moment(a.first_conversion_at).diff(a.created_at, 'days');
		})));

		const average = averages.reduce((sum, avg, i) => {
			return sum + (avg * registrations[i].activated_affiliates.length || 0);
		}, 0) / $total[path].registrations.activated_affiliates.length;

		return (
			<tr className={cn(!!levels.length && 'level-1')}>
				<td className='sticky'>
					<div>
						{intl('Средний срок активации')}
					</div>
				</td>

				<td colSpan={2}>
					{(!isNaN(average) && isFinite(average)) ? Math.round(average) : '−'}
				</td>

				{averages.map((average, i) => (
					<td colSpan={2} key={i}>
						{!isNaN(average) ? Math.round(average) : '−'}
					</td>
				))}
			</tr>
		);
	}

	renderConversionsList(path, key) {
		const levels = this.state.levels;
		const id = path + key + ':leads';

		if (!levels.includes(id)) return;

		const mapper = (filters) => (row) => ({
			amount: sumBy(filter(row[key], filters), 'amount'),
			profit: sumBy(filter(row[key], filters), 'profit')
		});

		const createWithTotal = (row) => ({
			...row, total: {
				amount: sumBy(row.months, 'amount'),
				profit: sumBy(row.months, 'profit')
			}
		});

		const list = this.sortBy(this.transformation(path, key, 'amount', mapper, createWithTotal), 'amount');

		return this.renderList(id, list, (id, info) => {
			return renderConversionsTDs(id, info.amount, info.profit);
		});
	}

	renderConversions(path, key) {
		const levels = this.state.levels;
		const id = path + key + ':leads';

		const rows = get(this.props.data, path);

		const months = rows.map((row) => row[key]);

		const list = months.map((affiliates) => ({
			amount: sumBy(affiliates, 'amount'),
			profit: sumBy(affiliates, 'profit')
		}));

		return !!months.length && (
			<tr className={cn(!!levels.length && 'level-1')}>
				<td className='sticky'>
					<button onClick={() => this.toggleLevel(id)}>
						<span>{levels.includes(id) ? '—' : '+'}</span>{this.props.intl('Лиды и маржа')}
					</button>
				</td>

				{renderConversionsTDs('total', sumBy(list, 'amount'), sumBy(list, 'profit'))}
				{list.map((info, i) => renderConversionsTDs(i, info.amount, info.profit))}
			</tr>
		);
	}

	renderRowList(path, key, targetKey) {
		const levels = this.state.levels;
		const id = path + key;

		if (!levels.includes(id)) return;

		const mapper = (filters) => (row) => ({
			targetCount: !targetKey ? 0 : filter(row[targetKey], filters).length,
			count: filter(row[key], filters).length
		});

		const createWithTotal = (row) => ({
			...row, total: {
				targetCount: sumBy(row.months, 'targetCount'),
				count: sumBy(row.months, 'count')
			}
		});

		const list = this.sortBy(this.transformation(path, key, null, mapper, createWithTotal), 'count');

		return this.renderList(id, list, (id, info) => {
			return renderTDs(id, info.count, targetKey && id.startsWith('field') ? info.targetCount : null);
		});
	}

	renderRow(title, path, key, targetKey) {
		const $total = this.props.data.$total;
		const levels = this.state.levels;
		const id = path + key;

		const $tlink = this.requestAffiliatesLink(get($total, path), key);

		const rows = get(this.props.data, path);

		return !!rows.length && (
			<tr className={cn(!!levels.length && 'level-1')}>
				<td className='sticky'>
					<button onClick={() => this.toggleLevel(id)}>
						<span>{levels.includes(id) ? '—' : '+'}</span>{title}
					</button>
				</td>

				{renderTDs('total', get($total, path.split('.').concat(key)).length, targetKey && get($total, path.split('.').concat(targetKey)).length, $tlink)}

				{rows.map((row) => {
					const link = this.requestAffiliatesLink(row, key);
					return renderTDs(row.month, row[key].length, targetKey && row[targetKey].length, link);
				})}
			</tr>
		);
	}

	render() {
		const { intl, filters, calendar, data, ...props } = this.props;

		const sorting = this.state.sorting;

		return (
			<div className='marketing-funnel'>
				<div className='marketing-funnel-actions'>
					<div className='marketing-funnel-filters clearfix'>
						<Filters
							intl={intl} {...filters} filters={filters} // for crutch support
						/>
					</div>
					<Calendar
						intl={intl}
						{...calendar}
						ranges={{
							...calendar.ranges,
							'Last year': {
								startDate: e => e.subtract(1, 'year').startOf('year'),
								endDate: e => e.subtract(1, 'year').endOf('year')
							}
						}}
						onInit={calendar.calendarInit}
						onToggle={calendar.calendarToggle}
						onChange={calendar.calendarChange}
						onApply={calendar.calendarApply}
					/>
					<button
						className='ui-btn ui-btn-primary'
						onClick={props.apply}
					>
						{intl('Apply')}
					</button>
					<button
						className='ui-btn ui-btn-secondary ui-icon-clear'
						onClick={props.clear}
					/>
				</div>

				<div className='marketing-funnel-table-wrapper'>
					<table>
						<thead>
							<tr>
								<th className='sticky' />

								<th
									className='marketing-funnel-sorting'
									onClick={() => this.sort(undefined)}
									colSpan={2}
								>
									<span className={cn(sorting.index === undefined && sorting.direction)}>
										{intl('Total')}
									</span>
								</th>

								{data.months.map((month, i) => (
									<th
										className='marketing-funnel-sorting'
										onClick={() => this.sort(i)}
										colSpan={2}
										key={month}
									>
										<span className={cn(sorting.index === i && sorting.direction)}>
											{month.format('MMM YY')}
										</span>
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{this.renderRow(intl('Кол-во регистраций'), 'all.registrations', 'affiliates')}
							{this.renderRowList('all.registrations', 'affiliates')}

							{this.renderRow(intl('Подтвержденные'), 'all.registrations', 'approved_affiliates', 'affiliates')}
							{this.renderRowList('all.registrations', 'approved_affiliates', 'affiliates')}

							{this.renderRow(intl('Активированные'), 'all.registrations', 'activated_affiliates', 'approved_affiliates')}
							{this.renderRowList('all.registrations', 'activated_affiliates', 'approved_affiliates')}

							{this.renderAverageActivationDays('all')}

							{this.renderConversions('all.registrations', 'affiliates')}
							{this.renderConversionsList('all.registrations', 'affiliates')}

							<tr className='empty' />

							{!data.all.transitions.length && (
								<button
									className='ui-btn ui-btn-primary'
									onClick={() => props.fetchDataByName('all.transitions')}
								>
									{intl('Реактивированные')}
								</button>
							)}

							{this.renderRow(intl('Кол-во переходов'), 'all.transitions', 'affiliates')}
							{this.renderRowList('all.transitions', 'affiliates')}

							{this.renderRow(intl('Реактивированные'), 'all.transitions', 'reactivated', 'affiliates')}
							{this.renderRowList('all.transitions', 'reactivated', 'affiliates')}

							{this.renderConversions('all.transitions', 'reactivated')}
							{this.renderConversionsList('all.transitions', 'reactivated')}

							<tr className='empty' />

							<tr>
								{intl('Конференции')}:
							</tr>

							<tr className='empty' />

							{this.renderRow(intl('Кол-во регистраций'), 'conferences.registrations', 'affiliates')}
							{this.renderRowList('conferences.registrations', 'affiliates')}

							{this.renderRow(intl('Подтвержденные'), 'conferences.registrations', 'approved_affiliates', 'affiliates')}
							{this.renderRowList('conferences.registrations', 'approved_affiliates', 'affiliates')}

							{this.renderRow(intl('Активированные'), 'conferences.registrations', 'activated_affiliates', 'approved_affiliates')}
							{this.renderRowList('conferences.registrations', 'activated_affiliates', 'approved_affiliates')}

							{this.renderAverageActivationDays('conferences')}

							{this.renderConversions('conferences.registrations', 'affiliates')}
							{this.renderConversionsList('conferences.registrations', 'affiliates')}

							<tr className='empty' />

							{!data.conferences.transitions.length && (
								<button
									className='ui-btn ui-btn-primary'
									onClick={() => props.fetchDataByName('conferences.transitions')}
								>
									{intl('Реактивированные')}
								</button>
							)}

							{this.renderRow(intl('Реактивированные'), 'conferences.transitions', 'reactivated')}
							{this.renderRowList('conferences.transitions', 'reactivated')}

							{this.renderConversions('conferences.transitions', 'reactivated')}
							{this.renderConversionsList('conferences.transitions', 'reactivated')}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(wrapMain(Table));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/main/main.js